export function getDisclaimerMessages(dataSourceType: string) {
    if (dataSourceType === "field_service_reports") {
        return ["For internal use only. Do not distribute."];
    }
    return [];
}
